import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../openapi';
import { captureException } from '@sentry/react';

declare module '@tanstack/query-core' {
  interface Register {
    defaultError: ApiError;
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (!error.status) {
          console.error(error);
          captureException(error);
        }

        if (error.status) {
          return error.status >= 500 && failureCount <= 5;
        }

        return failureCount <= 5;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
